/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../ricos-context';
import type { TFunction } from './../../ricos-types';
import { getScaleImageSrc } from './../../wix-rich-content-common/lib/imageUtils';

import styles from '../statics/styles/widget-scss';
import type { SubtitleInfo } from './CardContent';
import { CardContent } from './CardContent';

const getImageTargetHeight = (width: number, height: number, targetWidth: number) => {
  const proportion = height / width;
  const targetHeight = proportion * targetWidth;
  return targetHeight;
};

type CardProps = {
  title: string;
  buttonText: string;
  subtitleInfo?: SubtitleInfo;
  direction: 'ltr' | 'rtl';
  url: string;
  image?: { width?: number; height?: number; src: { url?: string } };
  disabled?: boolean;
  t: TFunction;
};

const Card: React.FC<CardProps> = props => {
  const { tabIndex } = useContext(RicosContext);

  const getImageSrc = ({ targetWidth }: { targetWidth: number }) => {
    if (props.image && props.image.width && props.image.height && props.image.src?.url) {
      const targetHeight = getImageTargetHeight(props.image.width, props.image.height, targetWidth);
      return getScaleImageSrc(props.image.src.url, targetWidth, targetHeight);
    }
    return props.image?.src?.url;
  };

  const [imageSrc, setImageSrc] = useState<string | undefined>(() =>
    // value for ssr and first render
    getImageSrc({ targetWidth: 185 })
  );

  // This ref is fn is called on every render, because its recrated on every
  // render, but its hard to tell if its needed. Overall we should redo this
  // with wix-image as reloading image on window resizing is not optimal
  const setRef = (ref: HTMLElement | null) => {
    if (ref && props.image?.width && props.image?.height) {
      const targetWidth = ref.getBoundingClientRect()?.width;
      setImageSrc(getImageSrc({ targetWidth }));
    }
  };

  const imageStyle = imageSrc ? { backgroundImage: `url(${imageSrc})` } : {};

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      className={styles.link}
      href={props.disabled ? undefined : props.url}
      target="_blank"
      ref={setRef}
      tabIndex={tabIndex}
    >
      <div
        style={{ direction: props.direction as 'rtl' | 'ltr' }}
        className={classNames(styles[props.direction], styles.container, styles.cardLayout)}
      >
        {imageSrc && <div style={imageStyle} className={styles.image} />}
        <CardContent
          info={props.subtitleInfo}
          title={props.title}
          buttonText={props.buttonText}
          disabled={props.disabled}
          t={props.t}
        />
      </div>
    </a>
  );
};

export default Card;
